import SETTINGS from '../../constants/#SETTINGS';

export interface SetSettingOptions {
  namespace?: string;
}

const setSetting = (key: string, value: string, { namespace = SETTINGS.DEFAULT_NAMESPACE }: SetSettingOptions = {}) => (
  localStorage.setItem(`[${namespace}] ${key}`, value)
);

export default setSetting;
